import React from 'react';

export interface Props {
  titulo?: string;
  children: React.ReactElement | React.ReactElement[] | string;
  exibir: boolean;
  aoFechar: (estado: boolean) => void;
}

const OffCanvas = ({
  titulo,
  children,
  exibir,
  aoFechar,
}: Props): React.ReactElement => {
  return (
    <React.Fragment>
      {exibir && (
        <div>
          <div
            className="offcanvas offcanvas-end show animate__animated animate__slideInRight animate__faster"
            style={{ visibility: 'visible' }}
          >
            <div className="offcanvas-header">
              <h5 id="offcanvasRightLabel">{titulo}</h5>
              <button
                type="button"
                className="btn-close text-reset"
                onClick={() => aoFechar(false)}
              ></button>
            </div>
            <div className="offcanvas-body">{children}</div>
          </div>
          <div
            className="offcanvas-backdrop fade show"
            onClick={() => aoFechar(false)}
          ></div>
        </div>
      )}
    </React.Fragment>
  );
};

export default OffCanvas;
